
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"},"content":"<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20.5 4.002v3.501a1 1 0 0 0 1 1H25l-4.5-4.5Z\" fill=\"#FFF\" opacity=\".5\"/><path d=\"M20.5 4 25 8.52V26a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11.5Z\" fill=\"#1D74F5\"/><path d=\"M20.5 4.002v3.501a1 1 0 0 0 1 1H25l-4.5-4.5Z\" fill=\"#FFF\" opacity=\".5\"/><path d=\"M15.417 20.622c-.82.82-2.197.772-3.076-.106-.879-.88-.926-2.256-.106-3.076l4.867-4.868c.592-.592 1.587-.558 2.222.077.634.635.669 1.63.076 2.222l-4.867 4.867c-.364.364-.977.343-1.367-.047-.39-.391-.412-1.003-.047-1.368l3.547-3.547c.137-.137.366-.129.513.018.146.146.154.376.017.512l-3.547 3.548c-.091.09-.086.244.012.342.097.097.25.102.342.011l4.867-4.867c.319-.319.3-.854-.041-1.196-.342-.342-.878-.36-1.197-.041l-4.867 4.867c-.546.547-.515 1.465.071 2.05.586.586 1.504.618 2.05.071l4.703-4.702c.137-.137.366-.129.512.018.147.146.155.376.018.512l-4.702 4.703Z\" fill=\"#FFF\"/></g>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest && dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
